"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = function (dealType, offerType) { return ({
    apiType: 'legacy',
    assertStatusCodes: [200],
    method: 'POST',
    microserviceName: 'monolithPython',
    pathApi: "/ajax/" + dealType + "/" + offerType + "/favorites",
}); };
function createFavoritesModel(dealType, offerType, config) {
    return __assign({}, exports.defaultConfig(dealType, offerType), config);
}
exports.createFavoritesModel = createFavoritesModel;
//# sourceMappingURL=favorites.js.map